import { DeviceIdentificationType } from '@quadminds/shared/tracking-system';

export interface IGetDeviceEventsDto {
    identificationType?: DeviceIdentificationType;
    identificationValue?: string;
    from?: string;
    to?: string;
    eventId?: string;
    eventType?: string;
    deviceExternalId?: string;
    limit?: number;
    page?: number;
    sort?: string;
}
